import styled from 'styled-components'

import type { ChipProps } from './Chip.types'

const StChip = styled.div<ChipProps>`
  display: inline-flex;
  align-self: start;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;

  ${({ theme, type, larger, thin }) => {
    return `
      color: ${theme.Components.Chip[type].Text};
      border-color: ${theme.Components.Chip[type].Border};
      background-color: ${theme.Components.Chip[type].Fill};

      font-size: ${larger ? '14px' : '12px'};
      font-weight: ${thin ? '400' : '700'};
      border-width: 1px;
      border-style: solid;
      border-radius: 100px;

      padding: ${larger ? theme.UI.SpacingPx.Space2 : theme.UI.SpacingPx.Space1} ${theme.UI.SpacingPx.Space4};
    `
  }}

  ${({ glass }) =>
    glass
      ? `
          background: rgba(255, 255, 255, 0.5);
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(5px);
          -webkit-backdrop-filter: blur(5px);
      `
      : null}

  ${({ active, theme }) =>
    active
      ? `
          border-color: ${theme.Components.Button.Secondary.Border}};
          background: ${theme.Components.Button.Secondary.Text};
          color: ${theme.Components.Button.Secondary.ActiveFill};
      `
      : null}
`

export { StChip }
